function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Letter-of-Intent-(Change-Orders)",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M191.196,2.27373675e-13 C135.721,2.27373675e-13 87.88,13.402 52.843,38.759 C19.261,63.063 0,97.381 0,132.916 C0,156.935 7.532,169.301 9.34,172.915 C9.661,173.557 10.531,173.936 11.08,173.474 C59.498,132.882 168.168,150.323 231.763,264.08 C232.218,264.895 233.364,264.961 233.918,264.211 L364.041,89.951 C366.785,86.237 364.132,80.981 359.517,80.987 L156.389,81.366 C154.007,81.369 153.534,84.738 155.819,85.406 C231.008,107.389 257.608,152.559 257.608,152.559 L233.459,184.757 C207.161,146.608 129.262,97.107 47.152,117.094 C47.152,112.1 57.295,71.408 117.589,51.257 C136.445,44.955 167.155,40.653 197.346,40.653 L370.969,41.031 C386.446,41.063 401.077,33.96 410.633,21.774 L425.037,2.411 C425.627,1.619 425.063,0.492 424.076,0.49 L191.196,2.27373675e-13",
  id: "logoSymbol",
  fill: "#000000"
}));

function SvgLogoSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "426px",
    height: "265px",
    viewBox: "0 0 426 265",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logoSymbol") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbol);
export default __webpack_public_path__ + "static/media/logoSymbol.9397cffa.svg";
export { ForwardRef as ReactComponent };